import { makeStyles } from "$components/mui-styles";
import { Grid } from "@material-ui/core";
import NoPrint from "./NoPrint";
import { ScrollToTop } from "./ScrollToTop";

const useStyles = makeStyles(() => ({
  layout: {
    minHeight: "100vh",
    minWidth: "100vw",
    width: "100vw",
  },
}));

/**
 * @deprecated: Use `$components/layout/app-layout` instead
 */
const Layout = ({ children }: WithChildren) => {
  const classes = useStyles();

  return (
    <NoPrint>
      <ScrollToTop />
      <Grid
        className={classes.layout}
        container
        direction="column"
        wrap="nowrap"
      >
        {children}
      </Grid>
    </NoPrint>
  );
};

export default Layout;
